module.exports = __webpack_public_path__ + "img/first-section-2.4c0ffb40.jpg";